const locationMapStyle = [
  {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "saturation": "-35"
      }
    ]
  }
]

export default locationMapStyle;
